import React, { useState, useEffect } from "react";

export const svg = `<svg width="32" height="24" viewbox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#discover-icon-a)"><path d="M0 3a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Z" fill="#E5EBEF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M4.314 12.665c-.286.26-.658.373-1.247.373h-.244V9.93h.244c.589 0 .946.107 1.247.38.315.283.504.72.504 1.17 0 .452-.189.902-.504 1.185ZM3.25 9.135H1.912v4.699h1.33c.708 0 1.219-.168 1.667-.543a2.363 2.363 0 0 0 .848-1.804c0-1.387-1.03-2.353-2.507-2.353Zm2.926 4.699h.911v-4.7h-.911v4.7Zm3.139-2.897c-.547-.203-.707-.337-.707-.591 0-.296.286-.521.678-.521.273 0 .497.113.735.38l.476-.628a2.036 2.036 0 0 0-1.372-.52c-.826 0-1.457.577-1.457 1.346 0 .647.294.979 1.15 1.289.356.126.538.21.63.267.181.12.272.29.272.487 0 .38-.3.662-.707.662-.434 0-.785-.218-.994-.627l-.589.57c.42.62.924.896 1.617.896.947 0 1.611-.634 1.611-1.543 0-.747-.307-1.085-1.343-1.467Zm1.63.55c0 1.381 1.078 2.453 2.466 2.453.392 0 .728-.078 1.142-.274v-1.08c-.365.367-.687.515-1.1.515-.918 0-1.569-.669-1.569-1.62 0-.903.672-1.615 1.527-1.615.434 0 .763.156 1.142.53v-1.08c-.4-.203-.729-.288-1.121-.288a2.464 2.464 0 0 0-2.487 2.46Z" fill="#212D34"></path><g filter="url(#discover-icon-b)"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.819 11.5c0 1.38-1.112 2.5-2.485 2.5a2.492 2.492 0 0 1-2.484-2.5c0-1.38 1.112-2.5 2.484-2.5a2.492 2.492 0 0 1 2.485 2.5Z" fill="url(#discover-icon-c)"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="m21.776 12.29-1.245-3.156h-.995l1.982 4.82h.49l2.018-4.82h-.988l-1.262 3.157Zm2.661 1.543h2.584v-.795h-1.673v-1.269h1.611v-.796h-1.611V9.93h1.673v-.796h-2.584v4.7Zm4.363-2.535h-.266V9.874h.28c.568 0 .876.24.876.697 0 .472-.308.727-.89.727Zm1.828-.777c0-.88-.603-1.387-1.653-1.387h-1.351v4.7h.91v-1.889h.119l1.26 1.888h1.12l-1.47-1.98c.687-.14 1.065-.612 1.065-1.332Z" fill="#212D34"></path><path d="M32 15v9H6.726C20.041 21.83 29.123 17.096 32 15Z" fill="#F68121"></path></g><defs><linearGradient id="discover-icon-c" x1="274.421" y1="99.099" x2="232.677" y2="50.034" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA700"></stop><stop offset="1" stop-color="#E75A10"></stop></linearGradient><clipPath id="discover-icon-a"><path d="M0 3a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Z" fill="#fff"></path></clipPath><filter id="discover-icon-b" x="14.85" y="9" width="5.544" height="5.575" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx=".575" dy=".575"></feOffset><feGaussianBlur stdDeviation=".707"></feGaussianBlur><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite><feColorMatrix values="0 0 0 0 0.314068 0 0 0 0 0.00146228 0 0 0 0 0.00146228 0 0 0 0.5 0"></feColorMatrix><feBlend in2="shape" result="effect1_innerShadow"></feBlend></filter></defs></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
